import { Tooltip } from "@mantine/core";
import {
  IconFeather,
  IconHomeBolt,
  type IconProps,
  IconStar
} from "@tabler/icons-react";
import { SiteLicense } from "../../../../types/api.types";
import { THEME_VARS } from "../../../../utils/constants";

interface LicenseIconProps {
  license: SiteLicense;
  iconProps?: IconProps;
}

function LicenseIcon({ license, iconProps }: LicenseIconProps) {
  switch (license) {
    case SiteLicense.premium:
      return (
        <Tooltip label="Premium-Lizenz">
          <IconStar color={THEME_VARS.warning[6]} {...iconProps} />
        </Tooltip>
      );
    case SiteLicense.light:
      return (
        <Tooltip label="Light-Lizenz">
          <IconFeather color="lightblue" {...iconProps} />
        </Tooltip>
      );
    case SiteLicense.standard:
      return (
        <Tooltip label="Basis-Lizenz">
          <IconHomeBolt color={THEME_VARS.primary[6]} {...iconProps} />
        </Tooltip>
      );
    default:
      return null;
  }
}

export { LicenseIcon };
